import { handleDiscoverTauri } from '@ui/Utils/scan/handleDiscoverTauri';

import { ScanStrategy } from '../types';

interface TauriDiscoveryRaw {
    [key: string]: unknown;
    device_group_id?: string;
    devicespec_id?: number | null;
    id?: string;
}

function extractIds(raw: TauriDiscoveryRaw) {
    const groupId = raw.id || raw.device_group_id || '';
    const devicespecId = raw.devicespec_id ?? null;
    return { devicespecId, groupId };
}

export const tauriStrategy: ScanStrategy = {
    kind: 'tauri',
    async start(signal, _opts, onProgress) {
        onProgress({ progress: 5, title: 'Initializing device discovery' });
        const res = (await handleDiscoverTauri()) as unknown as TauriDiscoveryRaw | null;
        if (signal.aborted) {
            throw new Error('Aborted');
        }
        if (!res) {
            throw new Error('No device found');
        }
        onProgress({ progress: 70, title: 'Processing device specification' });
        const { devicespecId, groupId } = extractIds(res);
        onProgress({ progress: 90, title: 'Finalizing' });
        return { devicespecId, groupId, raw: res };
    },
};
